import React, { FunctionComponent, ReactNode, useEffect, useState } from 'react'
import { Note } from './BriefSectionTypes'
import { PinnedNotesCard } from './PinnedNotesCard'
import styles from './BriefShell.module.css'

interface Props {
  children: ReactNode
  activeSideNotes: boolean
  note?: Note
  segmentTestId: string
  noteTestId: string
  noteTitle?: string
  onNoteLayoutChange?: () => void
  /** the brief's first note opens with its full explanation showing */
  defaultExpanded?: boolean
}

export const SectionWithNote: FunctionComponent<Props> = ({
  children,
  activeSideNotes,
  note,
  segmentTestId,
  noteTestId,
  noteTitle,
  onNoteLayoutChange,
  defaultExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  useEffect(() => {
    setExpanded(defaultExpanded)
  }, [note?.id, defaultExpanded])

  const handleToggle = () => {
    setExpanded(previous => !previous)
    onNoteLayoutChange?.()
  }

  const hasPinnedNote = Boolean(note?.explanation?.some(paragraph => paragraph.trim().length > 0))
  const showPinnedNote = activeSideNotes && hasPinnedNote

  return (
    <div
      className={`${styles.sectionWithNote}${!showPinnedNote ? ` ${styles.notesHidden}` : ''}`}
      data-testid={segmentTestId}
    >
      {children}

      {showPinnedNote && (
        <div className={styles.absoluteNote}>
          <PinnedNotesCard
            note={note!}
            expanded={expanded}
            onToggle={handleToggle}
            testId={noteTestId}
            title={noteTitle}
          />
        </div>
      )}
    </div>
  )
}
